import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollToTop — resets scroll position on route change.
 * Skips scroll-to-top on POP navigation (browser back/forward button)
 * so that the user returns to their previous scroll position.
 *
 * Must be rendered inside BrowserRouter, before <Routes>.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    // POP = browser back/forward — preserve scroll position
    if (navType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navType]);

  return null;
}
